import clsx from 'clsx'
import dayjs from 'dayjs'

import { useNetwork } from '@tribeplatform/react-sdk/hooks'

const DAYS_BEFORE_PLAN_BOX_IN_SIDEBAR = 14
export const TrialProgress = () => {
  const { data: network } = useNetwork()
  const plan = network?.subscriptionPlan
  const trial = plan?.trial

  if (trial && plan?.endDate) {
    const trialLeftInDays = Math.max(
      0,
      dayjs(plan?.endDate).diff(dayjs().add(-1, 'day'), 'day'),
    )

    if (trialLeftInDays > DAYS_BEFORE_PLAN_BOX_IN_SIDEBAR) {
      return null
    }

    return (
      <a
        href="/admin/community/billing"
        className={clsx(
          trialLeftInDays <= 3
            ? 'bg-indigo-600 text-basicPrimary-500 p-2'
            : 'bg-main-100 hover:bg-main-200 text-basicMain-900 py-2 px-3',
          'group rounded-lg flex space-x-2',
        )}
      >
        {trialLeftInDays <= 3 && (
          <div className="flex-shrink-0 flex items-center">
            <div className={clsx('rounded-lg p-2 bg-indigo-800')}>
              <img
                src="/images/icons/upgrade-icon.svg"
                alt="Upgrade plan icon"
                className="w-6 h-6 flex-shrink-0"
              />
            </div>
          </div>
        )}
        <div className="flex-col space-y-0.5 text-sm">
          <div>
            Your trial will end in {trialLeftInDays}{' '}
            {trialLeftInDays === 1 ? 'day' : 'days'}
          </div>
          <div>
            <a className="font-medium group-hover:underline">Upgrade now</a>
          </div>
        </div>
      </a>
    )
  }
  return null
}
